import { getJson, postJson, putJson, deleteJson, withDone, withOptional, withValidate } from '@rad/utility/http';
export const getDiscussion = (id) => withOptional(getJson(`/api/discussions/${id}`));
export const createDiscussion = (form) => withDone(withValidate(postJson('/api/discussions', form)))();
export const updateDiscussion = (id, form) => withDone(withValidate(putJson(`/api/discussions/${id}`, form)))();
export const updateDiscussionStatus = (id, status) => withDone(postJson(`/api/discussions/${id}/status`, { status }))();
export const deleteDiscussion = (id) => withDone(deleteJson(`/api/discussions/${id}`))();
export const createComment = (discussionId, form) => withDone(withValidate(postJson(`/api/discussions/${discussionId}/comments`, form)))();
export const deleteComment = (discussionId, commentId) => withDone(deleteJson(`/api/discussions/${discussionId}/comments/${commentId}`))();
export const markAsRead = (id) => withDone(postJson(`/api/discussions/${id}/mark-read`, {}))();
export const markAllAsRead = () => withDone(postJson('/api/discussions/mark-all-read', {}))();
export const fetchDiscussionsPage = (sortBy, status, search, categoryId, kinds) => (page, pageSize) => withDone(getJson('/api/discussions', {
    page, pageSize, sortBy,
    status: status !== 'all' ? status : undefined,
    search: search || undefined,
    categoryId: categoryId || undefined,
    kind: kinds
}))();
export const getCategories = () => getJson('/api/discussions/categories');
export const getUnreadCount = () => getJson('/api/discussions/unread-count');
export const getPublicKinds = () => getJson('/api/discussions/public-kinds');
export const fetchPublicDiscussionsPage = (sortBy, status, search) => (page, pageSize) => withDone(getJson('/api/discussions/public', {
    page, pageSize, sortBy,
    status: status !== 'all' ? status : undefined,
    search: search || undefined,
}))();
export const getPublicDiscussion = (id) => withOptional(getJson(`/api/discussions/public/${id}`));
export const getAccessRequestStatus = () => withDone(getJson('/api/discussions/access-request-status'))();
export const requestAccess = () => withDone(postJson('/api/discussions/request-access', {}))();
export const followDiscussion = (id) => withDone(postJson(`/api/discussions/${id}/follow`, {}))();
export const unfollowDiscussion = (id) => withDone(deleteJson(`/api/discussions/${id}/follow`))();
export const toggleDiscussionReaction = (id, emoji) => withDone(postJson(`/api/discussions/${id}/reactions`, { emoji }))();
export const toggleCommentReaction = (discussionId, commentId, emoji) => withDone(postJson(`/api/discussions/${discussionId}/comments/${commentId}/reactions`, { emoji }))();
